import React from 'react';
import { createUseStyles } from 'react-jss';
import { DynamicGridActionIcons } from './dynamic-grid-action-icons';

const useStyles = createUseStyles({
    actionsOuter: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    actionsInner: {
        transition: 'opacity 120ms ease',
    },

    hidden: {
        '& $actionsInner': {
            opacity: 0,
            pointerEvents: 'none',
        },
    },

    visible: {
        '& $actionsInner': {
            opacity: 1,
            pointerEvents: 'auto',
        },
    },
});

interface DynamicGridActionsProps {
    className?: string;
    isDeleteDisabled?: boolean;
    isHovered?: boolean;
    onDelete?: () => void;
    onPopover?: () => void;
    showHeaderMenuPopover?: boolean;
}

export function DynamicGridActions({
    className,
    isDeleteDisabled,
    isHovered = false,
    onDelete,
    onPopover,
    showHeaderMenuPopover,
}: DynamicGridActionsProps) {
    const classes = useStyles();

    const visibilityClass = showHeaderMenuPopover ? classes.hidden : isHovered ? classes.visible : classes.hidden;

    return (
        <div className={`${classes.actionsOuter} ${visibilityClass} ${className ?? ''}`}>
            <div className={classes.actionsInner}>
                <DynamicGridActionIcons onDelete={onDelete} onPopover={onPopover} isDeleteDisabled={isDeleteDisabled} />
            </div>
        </div>
    );
}
